<template>
    <div class="questionData">
        <van-nav-bar title="问题反馈清单发起" @click-left="onClickLeft" left-arrow />
        <van-field style="margin-bottom: 20px;" required label="问题反馈清单标题：" title-class="colorBlack" label-width="200"
            maxlength="30" v-model="addfbForm.title" input-align="right" placeholder="请输入标题，仅限30字" />

        <van-cell required title="问题反馈清单内容:">
            <template #label>
                <div style="width: 100%;color: rgba(51, 51, 51, 0.8);">
                    <div class="rich-container">
                        <div class="rich-editor document-editor">
                            <div id="toolbar-container" class="document-editor__toolbar" />
                            <div class="document-editor__editable-container">
                                <div ref="editor" id="editor" class="document-editor__editable"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </van-cell>
        <!-- <div style="height:30px;font-size:14px;margin:5px 0px 5px 8px" class="colorBlack">
            <span style="color:red">*</span>
            问题反馈清单内容:
        </div>
        <div class="rich-container">
            <div class="rich-editor document-editor">
                <div id="toolbar-container" class="document-editor__toolbar" />
                <div class="document-editor__editable-container">
                    <div ref="editor" id="editor" class="document-editor__editable"></div>
                </div>
            </div>
        </div> -->

        <div style="width: 90%; margin: 20px auto;display: flex;">
            <!-- <van-button type="default" style="width: 40%; margin: auto" round @click="continueBtn()">取消</van-button> -->
            <van-button :loading="loading" type="info" style="width: 100%; margin: auto" round
                @click="onSubmit()">确认发起</van-button>
        </div>
    </div>
</template>
<script>
import {
    AddYwFeedback
} from "@/api/index";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import "@ckeditor/ckeditor5-build-decoupled-document/build/translations/zh-cn";
import UploadAdapter from "../../DD_schedule/uploadAdapter.js";
export default {
    name: "questionData",
    data() {
        return {
            addfbForm: {
                title: '',
                content: '',
            },
            // editor: DecoupledEditor,
            editor: null,
            loading: false
        }
    },
    methods: {
        initCKEditor() {
            // 初始化编辑器
            DecoupledEditor.create(document.querySelector("#editor"), {
                language: "zh-cn", // 中文
                removePlugins: ["MediaEmbed"], // 除去视频按钮
                toolbar: {
                    items: [ //工具栏
                        // "heading",//段落或标题样式
                        // "|",
                        // "fontfamily",//字体
                        // "fontsize",//字体大小
                        // "|",
                        // "alignment",//对齐
                        // "|",
                        // "fontColor",//字体颜色
                        // "fontBackgroundColor",//背景颜色
                        // "|",
                        // "bold",//加粗
                        // "italic",//倾斜
                        // "strikethrough",//删除线
                        // "underline",//下划线
                        // "|",
                        // "link",//超链接
                        // "|",
                        // "outdent",//减少缩进
                        // "indent",//增加缩进
                        // "|",
                        // "bulletedList",//项目符号列表
                        // "numberedList",//项目编号列表
                        // "|",
                        // "insertTable",//插入表格
                        // "|",
                        "uploadImage",//插入图片
                        // "blockQuote",//引用
                        "|",
                        "undo",//撤销
                        "redo",//重做
                    ]
                }
            })
                .then((editor) => {
                    editor.plugins.get("FileRepository").createUploadAdapter = (
                        loader
                    ) => {
                        return new UploadAdapter(loader);
                    };
                    const toolbarContainer = document.querySelector("#toolbar-container");
                    toolbarContainer.appendChild(editor.ui.view.toolbar.element);
                    this.editor = editor; // 将编辑器保存起来，用来随时获取编辑器中的内容等，执行一些操作

                })
                .catch((error) => {
                    console.error(error);
                });
        },
        onSubmit() {
            this.addfbForm.content = this.editor.getData()
            if (this.addfbForm.title === '' || this.addfbForm.content === "") {
                this.$toast("请填写完整数据");
                return false;
            } else {
                this.loading = true;
                let fd = new FormData();
                fd.append("projectid", this.$store.state.pid);
                fd.append("type", this.$route.query.type);
                fd.append("fileId", this.$route.query.info.id);
                fd.append("title", this.addfbForm.title);
                fd.append("strcount", this.addfbForm.content);
                AddYwFeedback(fd).then((res) => {
                    if (res.Code != 0) {
                        this.$Notify({ type: "success", message: "操作成功!" });
                        this.addfbForm = {};
                        this.$router.push({
                            path: "/home/menu/construction",
                            query: { type: 0, title: '建设运维' },
                        });
                    } else {
                        this.$Notify({ type: "danger", message: res.Message });
                    }
                    this.loading = false;
                });
            }
        },
        onClickLeft() {
            this.$router.go(-1);
        },
    },
    mounted() {
        this.initCKEditor()
    },
}
</script>
<style lang="scss" scoped>
.questionData {
    width: 100%;
    height: 100%;
    background: #fff;

    .colorBlack {
        // color: rgba(51, 51, 51, 1);
        color: #646566
    }
}

.ck.ck-editor__editable:not(.ck-editor__nested-editable) {
    min-height: 600px !important;
}
</style>
